import { ThreeDots } from "react-loader-spinner";

const ScreenLoader = () => {
  return (
    <div className="roi--loader-screen">
      <ThreeDots
        visible={true}
        height="100"
        width="100"
        bgColor="#f5f8fa"
        color="#B9D9EB"
        textColor="#2D2926"
        radius="9"
        ariaLabel="three-dots-loading"
      />
    </div>
  );
};

export default ScreenLoader;
